export default "__VITE_ASSET__DrjKA$n6__"